'use strict';

angular.module('shiftTraderApp')
  .service('ViewDayOffModalService', ['$uibModal', 'AvailabilityRules', 'Session', function ($uibModal, AvailabilityRules, Session) {

    function openViewDayOffModal(dayOffId, callbackFn) {
      var modalInstance = $uibModal.open({
        size: 'view-day-off',
        templateUrl: 'views/daysOff/viewDayOffModal.html',
        controller: 'ViewDayOffModalCtrl',
        controllerAs: 'detailsCtrl',
        resolve: {
          params: function() {
            return {
              me: Session.me
            };
          },
          dayOff: ['AvailabilityRules', function(AvailabilityRules) {
            return AvailabilityRules.getById(dayOffId);
          }]
        }
      });

      modalInstance.result.then(function(res) {
        if (callbackFn) {
          callbackFn(1, res);
        }
      }, function(res) {
        if (callbackFn) {
          callbackFn(-1, res);
        }
      });


      return modalInstance;
    }

    return {
      openViewDayOffModal: openViewDayOffModal
    };

  }]);
